import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import {
  MultistepProtocolDto,
  CreateMultistepProtocolDto,
  FindMultistepProtocolsQuery,
} from '@services/api'
import { MultistepProtocolService } from '@services/MultistepProtocolService'

export interface MultistepProtocolState {
  multistepProtocols: MultistepProtocolDto[]
}

const initialState: MultistepProtocolState = {
  multistepProtocols: [],
}

export const doFindMultistepProtocols = createAsyncThunk<
  MultistepProtocolDto[],
  FindMultistepProtocolsQuery | undefined
>('multistepProtocol/findAll', async (query, { rejectWithValue }) => {
  try {
    return await MultistepProtocolService.findAll(query)
  } catch (err) {
    return rejectWithValue(err)
  }
})

export const doCreateMultistepProtocol = createAsyncThunk<
  MultistepProtocolDto,
  CreateMultistepProtocolDto
>('multistepProtocol/create', async (dto, { rejectWithValue }) => {
  try {
    return await MultistepProtocolService.create(dto)
  } catch (err) {
    return rejectWithValue(err)
  }
})

export const doUpdateMultistepProtocol = createAsyncThunk<
  MultistepProtocolDto,
  { id: number; dto: Partial<CreateMultistepProtocolDto> }
>('multistepProtocol/update', async ({ id, dto }, { rejectWithValue }) => {
  try {
    return await MultistepProtocolService.update(id, dto)
  } catch (err) {
    return rejectWithValue(err)
  }
})

export const doDeleteMultistepProtocol = createAsyncThunk<void, number>(
  'multistepProtocol/delete',
  async (id, { rejectWithValue }) => {
    try {
      await MultistepProtocolService.remove(id)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const multistepProtocolSlice = createSlice({
  name: 'multistepProtocol',
  initialState,
  reducers: {
    setMultistepProtocols: (state, action) => {
      state.multistepProtocols = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(doFindMultistepProtocols.fulfilled, (state, action) => {
        state.multistepProtocols = action.payload
      })
      .addCase(doCreateMultistepProtocol.fulfilled, (state, action) => {
        state.multistepProtocols.push(action.payload)
      })
      .addCase(doUpdateMultistepProtocol.fulfilled, (state, action) => {
        const index = state.multistepProtocols.findIndex(
          (p) => p.id === action.payload.id,
        )
        if (index !== -1) {
          state.multistepProtocols[index] = action.payload
        }
      })
      .addCase(doDeleteMultistepProtocol.fulfilled, (state, action) => {
        state.multistepProtocols = state.multistepProtocols.filter(
          (p) => p.id !== action.meta.arg,
        )
      })
  },
})

export default multistepProtocolSlice.reducer
